export const FirebaseConfig = {
	"projectId": "end-to-end-courier",
	"appId": "1:727116851023:web:fb5342270be857d94b873a",
	"databaseURL": "https://end-to-end-courier-default-rtdb.firebaseio.com",
	"storageBucket": "end-to-end-courier.firebasestorage.app",
	"apiKey": "AIzaSyCwVm64GWWbHTQS3ZxVitlYipjTSCrkJkc",
	"authDomain": "end-to-end-courier.firebaseapp.com",
	"messagingSenderId": "727116851023",
	"measurementId": "G-8034VJXT65"
};